var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultichoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multichoice-black",
    clipPath: "url(#clip0_309_12454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4425 20.6582L0 22.0629L1.20195 30.2852L62.5774 46.5323L15.4425 20.6582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4941 11.4312L20.6583 10.2292L18.0516 18.8538L64.5843 46.1326L33.4941 11.4312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3528 7.02041L43.3235 3.20898L37.3055 10.6291L65.5864 45.9302L53.3528 7.02041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5884 0L56.9618 7.02031L66.7912 45.9301L76.6177 6.61798L66.5884 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.256 2.80664L80.2293 7.42021L67.5933 45.7303L96.8765 10.6291L90.256 2.80664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.921 10.2292L99.8855 11.8338L68.7953 46.1326L116.13 19.0537L112.921 10.2292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.337 20.8582L70.3998 46.5323L132.577 30.8874L133.38 22.0629L118.337 20.8582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5032 73.6008V79.9147H12.34V76.6577H12.3589L13.5394 79.9147H14.5015L13.161 76.6577L14.4005 73.6008H13.5394L12.3746 76.6577H12.3482L12.34 73.6008H11.5032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5666 73.6008L21.194 79.9148H22.0149L22.2495 78.6835H23.5048L23.7393 79.9148H24.5842L23.2276 73.6008H22.5666ZM23.3769 78.0305H22.3721L22.8731 74.8242H22.8891L23.2063 77.119L23.3769 78.0305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.751 73.6008V79.9147H33.9953V79.1872H32.5881V73.6008H31.751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1381 73.6008V79.9147H43.3902V79.1872H41.9748V77.0414H43.241V76.3139H41.9748V74.3284H43.3902V73.6008H41.1381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M51.4952 73.6008H50.6583V79.9148H51.4952V73.6008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1312 73.6008V79.9148H59.7095C61.2074 79.9148 62.1802 79.7815 62.1802 76.8658C62.1802 73.6675 61.0581 73.6008 60.0693 73.6008L59.1312 73.6008ZM61.2927 76.8657C61.2927 77.9372 61.3513 79.2431 59.9707 79.2032V74.3124C61.3833 74.2298 61.2927 75.8956 61.2927 76.8658L61.2927 76.8657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1328 73.5181C69.507 73.5181 69.491 75.6209 69.491 76.759C69.491 77.8971 69.507 79.9999 71.1328 79.9999C72.7559 79.9999 72.7746 77.8971 72.7746 76.759C72.7719 75.6183 72.7559 73.5181 71.1328 73.5181ZM71.1328 74.3043C71.7937 74.3043 71.887 75.4184 71.887 76.759C71.887 78.0996 71.7937 79.2137 71.1328 79.2137C70.4718 79.2137 70.3785 78.0996 70.3785 76.759C70.3785 75.4184 70.4691 74.3043 71.1328 74.3043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1989 73.7261C81.928 73.5758 81.6209 73.503 81.3114 73.5155C80.3652 73.5155 79.8961 74.2432 79.8961 75.1307C79.8961 76.7885 81.6632 77.039 81.6632 78.297C81.6632 78.7661 81.4446 79.1765 80.9249 79.1765C80.6196 79.1638 80.3275 79.0483 80.096 78.8487V79.6936C80.36 79.8964 80.6854 80.0027 81.0182 79.9948C81.9483 79.9948 82.5001 79.2325 82.5001 78.345C82.5001 77.4921 82.1722 77.071 81.6045 76.4953L80.9675 75.7997C80.8078 75.6069 80.7244 75.3622 80.733 75.112C80.7257 75.009 80.7396 74.9056 80.7736 74.8081C80.8077 74.7106 80.8613 74.621 80.9311 74.5449C81.001 74.4688 81.0856 74.4078 81.1799 74.3655C81.2741 74.3233 81.376 74.3007 81.4793 74.2991C81.7397 74.3056 81.9903 74.3994 82.1909 74.5657L82.1989 73.7261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2708 73.702C92.0515 73.5709 91.7985 73.5069 91.5432 73.5181C89.8268 73.5181 89.6669 75.5943 89.6669 76.8603C89.6669 78.1823 89.8934 80 91.6018 80C91.8374 80.0092 92.0703 79.948 92.2708 79.8241V79.0884C92.1168 79.1713 91.9446 79.2143 91.7697 79.2137C90.6237 79.2137 90.5544 77.6386 90.5544 76.8017C90.5544 76.0154 90.5624 74.307 91.7351 74.307C91.9238 74.3171 92.1074 74.3719 92.2708 74.4669L92.2708 73.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.016 73.5181C99.3897 73.5181 99.3737 75.6209 99.3737 76.759C99.3737 77.8971 99.3897 79.9999 101.016 79.9999C102.639 79.9999 102.657 77.8971 102.657 76.759C102.655 75.6183 102.639 73.5181 101.016 73.5181ZM101.016 74.3043C101.676 74.3043 101.77 75.4184 101.77 76.759C101.77 78.0996 101.676 79.2137 101.016 79.2137C100.355 79.2137 100.261 78.0996 100.261 76.759C100.261 75.4184 100.352 74.3043 101.016 74.3043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.97 79.9148V77.119C112.276 77.1696 112.78 76.5752 112.78 75.2933C112.78 73.6701 111.858 73.6008 111.138 73.6008H110.133V79.9148H110.97ZM111.085 74.3125C111.722 74.3125 111.89 74.7895 111.89 75.3599C111.89 76.0635 111.69 76.458 110.968 76.4073V74.3151H111.085V74.3125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.995 73.6008V79.9147H122.247V79.1872H120.832V77.0414H122.098V76.3139H120.832V74.3284H122.247V73.6008H119.995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08531 52.2521L9.17913 49.5203H11.887V52.1056L15.088 49.5203L18.1157 49.5256V65.2852H14.9361L14.8454 51.3673L11.8897 53.7074C11.8897 53.7074 11.5912 62.2681 11.8044 65.2346L8.57144 65.2852V51.4926L5.23724 53.766L5.3625 65.2799L2.05493 65.2852V49.5256H5.08531L5.08531 52.2521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2809 52.4041H72.2202V50.8876L68.7154 50.8742L68.7873 64.2244C70 64.5656 71.3113 64.4137 71.9163 63.1637V61.7991H73.129C73.4701 63.3156 72.5213 64.5256 71.3113 65.1333L65.5517 65.2852L65.6663 51.2127C67.2201 48.7127 70.8369 49.8588 73.2809 49.6749V52.4041L73.2809 52.4041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9994 63.7688L29.6348 61.3435V52.4041H32.516V65.2852H29.6348V62.7079L25.6795 65.2799L23.1182 65.2852V52.4041H25.9994V63.7688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8503 64.3738L44.3362 64.3845V65.2852H37.8199V52.4041H40.8503V64.3738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3391 53.3129H51.0049L50.9942 65.2852H47.9745V53.3368L44.3362 53.3129V52.4041H54.3391V53.3129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M60.3998 52.4041H57.3694V65.2852H60.3998V52.4041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7976 58.0093L83.2835 55.5865V52.4041H86.3167V65.2852H83.2835V57.1004L79.7976 59.5257V65.2852H76.7672V52.4041H79.7976V58.0093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M109.198 52.4041H106.167V65.2852H109.198V52.4041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.021 54.8267H119.96V53.4621C119.24 53.1956 118.332 53.3475 117.535 53.3102L117.383 64.2217C117.913 64.4883 118.595 64.3363 119.2 64.3737C120.035 63.9179 119.995 63.0863 119.957 62.2521H120.866C121.055 63.4648 120.752 64.7521 119.502 65.1306H114.35C114.464 61.1913 114.083 57.0602 114.654 53.3102C116.093 51.6444 119.137 52.2255 121.018 52.4013V54.8267L121.021 54.8267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.325 53.1612H127.99L127.839 57.4042L130.568 57.3935V58.3131H127.99L127.839 64.3738L131.325 64.4192V65.2852H124.808V52.4041H131.325V53.1612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8002 52.5532C97.1109 52.6678 93.3609 51.455 91.4659 53.6139V64.2217C91.6552 64.8267 92.3002 65.0159 92.8305 65.1306C95.4078 65.0159 99.0832 66.2285 100.864 64.0697V53.6139C100.632 53.1554 100.259 52.7835 99.8002 52.5532ZM97.8332 64.3763H94.6509V53.4646H97.8332V64.3763Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_12454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133.38,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultichoice);
export default __webpack_public_path__ + "static/media/multichoice.2cb504d77d576b425b007946cdd89af7.svg";
export { ForwardRef as ReactComponent };